import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY ?? "AIzaSyD1YIaE-4HHzsjRpRYe2rJyeTPMbSENnQc",
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN??"auth.hypertask.ai",
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
}

// Validate Firebase config - authDomain is REQUIRED for authentication
if (!firebaseConfig.authDomain) {
  const errorMsg = `Firebase authDomain is missing! 
    Expected: NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN environment variable
    Current value: ${process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN}
    This will cause auth/auth-domain-config-required errors.
    Please set NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN in your environment variables.`;
  
  console.error('🔴 Firebase Config Error:', errorMsg);
  
  if (typeof window !== 'undefined') {
    // In browser, show a more user-friendly error
    console.error('Firebase authentication is not properly configured. Please contact support.');
  }
}

// Validate other critical config
if (typeof window !== 'undefined') {
  if (!firebaseConfig.apiKey || firebaseConfig.apiKey === "AIzaSyD1YIaE-4HHzsjRpRYe2rJyeTPMbSENnQc") {
    console.warn('⚠️ Firebase API key may not be configured properly (using default)');
  }
  
  // Log config status in development
  if (process.env.NODE_ENV === 'development') {
    console.log('🔵 Firebase Config:', {
      authDomain: firebaseConfig.authDomain ? '✅ Set' : '❌ Missing',
      apiKey: firebaseConfig.apiKey ? '✅ Set' : '❌ Missing',
      projectId: firebaseConfig.projectId ? '✅ Set' : '❌ Missing',
    });
  }
}

// Initialize Firebase - this will throw if config is invalid
let app;
let authInstance;

try {
  app = initializeApp(firebaseConfig);
  authInstance = getAuth(app);
  
  // Set auth domain explicitly if it wasn't in config (shouldn't happen, but just in case)
  if (!authInstance.config?.authDomain && firebaseConfig.authDomain) {
    console.warn('Firebase auth domain was not set during initialization');
  }
} catch (error: any) {
  console.error('🔴 Firebase initialization failed:', error);
  if (error.message?.includes('auth-domain-config-required')) {
    console.error('This error means NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN is not set in your environment variables.');
  }
  throw error;
}

export const auth = authInstance;
